import { render, staticRenderFns } from "./ConsultNoteRegister.vue?vue&type=template&id=94e6d644&scoped=true"
import script from "./ConsultNoteRegister.vue?vue&type=script&lang=js"
export * from "./ConsultNoteRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e6d644",
  null
  
)

export default component.exports